import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ChooserPage from "@/pages/ChooserPage";
import LandingPage from "@/pages/LandingPage";
import CareLanding from "@/pages/CareLanding";
import CareersPage from "@/pages/CareersPage";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/common/SmoothScroll";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <Routes>
          <Route path="/" element={<ChooserPage />} />
          <Route path="/acquisitions" element={<LandingPage />} />
          <Route path="/nj" element={<CareLanding />} />
          <Route path="/ny" element={<CareLanding />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
